<div class="wrapper">
    <div class="element" *ngFor="let item of textArray" [innerHTML]="item | safeHtml"></div>
</div>


// WEBPACK FOOTER //
// ./src/app/message-component/message-component.component.html